import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class PriceGuideService {
  baseHref = `${environment.dashboardBaseRef}api/price-guides`;

  constructor(private http: HttpClient) {}

  fetchPriceGuideCategories(): Observable<any[]> {
    const url = `${this.baseHref}/categories/active`;
    return this.http.get<any[]>(url);
  }
}
